import {
  BarberSharedForm,
  ShopSharedForm,
  BrandSharedForm,
} from '../SharedForm';
import enhance from './EditProductContainer';


export const BarberEditProduct = enhance(BarberSharedForm);
export const ShopEditProduct = enhance(ShopSharedForm);
export const BrandEditProduct = enhance(BrandSharedForm);
